var setSpecies = require('../internals/set-species');

// `Array[@@species]` getter
// https://tc39.github.io/ecma262/#sec-get-array-@@species
setSpecies('Array');



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/modules/es.array.species.js
// module id = 1348
// module chunks = 1